import { Entity } from '@/store/shared/entity'

export default class Sender extends Entity<number>{
    name:string;
    nameEn:string;
    attachment:string;
    address:string;
    taxIndentifierNumber:string;

}